// Interface labels live here until they are translated (#288).
export const INTERFACE_TEXT = {
  explainMeaningFallback: 'The character is speaking.',
  sceneBeatFallback: 'Here is the scene.',
  yourChoiceLabel: 'Your choice',
  handledLabel: 'Handled',
  tookAFewTriesLabel: 'Took a few tries',
  notHandledLabel: 'Not handled',
  noteOnFormLabel: 'Note on form',
  handledWithHelpLabel: 'Handled with help',
  helpButtonLabel: 'What did they say?',
  helpButtonText: '?',
  helpPanelHeading: 'What they said',
  helpDismissLabel: 'Hide explanation',
  helpLoading: 'Finding out…',
  helpUnavailable:
    "We couldn't explain that line right now. Please try again in a moment.",
  helpFailed: "We couldn't explain that line. Please try again.",
  tcWhoThem: 'They say',
  tcWhoYou: 'You say',
  tcWhoModel: 'Listen',
  tcWhoTurn: 'Your turn',
  tcNeedHelp: 'I need help',
  tcLadderMeaningLabel: 'It means',
  tcLadderCueLabel: 'It starts with',
  tcWorking: 'Checking…',
  tcContextHeading: 'They said',
  tcContextSpoke: 'They spoke.',
  tcReplayGroup: 'Hear it again',
  tcUnclearWord: 'unclear',
  tcRetryInvite: 'Try again, or ask for help. What you got still counts.',
  tcNoSpeechInvite:
    "I didn't hear anything. Tap the mic whenever you're ready.",
  tcAudioRetry: 'Try again',
  tcAudioRetryShort: 'Retry',
  tcAudioSkip: 'Skip this phrase',
  tcAudioFetchFailed: "The audio didn't load.",
  tcAudioMissing: "This phrase's audio isn't available.",
  tcAudioWontPlay: "The audio won't play.",
  tcAudioOnlyFetchFailed: "Couldn't load the audio.",
  tcAudioOnlyMissing: "This audio isn't available.",
  tsEyebrowLesson: 'Lesson',
  tsEyebrowCheckin: 'Check-in',
  tsLearnHeading: "What you'll learn",
  tsSoundOnHint: "You'll hear each new phrase, then say it. Sound on.",
  tsStart: 'Start',
  tsGettingReady: 'Getting ready…',
  tsBackToToday: 'Back to Today',
  rsHeading: 'Pick up where you left off',
  rsStep: 'Step {n} of {total}',
  rsRecapHeading: 'So far',
  rsPartN: 'Part {n}',
  rsOutcomeSuccess: 'Done',
  rsOutcomeSkipped: 'Moved on',
  rsOutcomeTriedAgain: 'Took a few tries',
  rsContinue: 'Continue',
  rsRestart: 'Restart',
  rsRestartHint: 'Restart begins again from the first step.',
  tsPause: 'Pause',
  rkRailLabel: 'Your lesson',
  rkLearnedHeading: 'Learned so far',
  rkReplayPrefix: 'Hear again:',
  rkKeysHeading: 'Keys',
  rkKeySpeak: 'speak',
  rkKeyAgain: 'again',
  rkKeySlower: 'slower',
  rkKeyPause: 'pause',
  tsLeaveAria: 'Leave and go to Today',
  tsPartsLabel: 'Parts',
  tsPartDone: 'done',
  tsPartCurrent: 'current',
  tsPartTodo: 'to come',
  tsPausedHeading: 'Paused',
  tsPausedBody:
    "Leaving now is fine. Nothing is lost; this just won't count as finished yet.",
  tsResume: 'Resume',
  tsLeaveHeading: 'Leave this session?',
  tsLeaveBody:
    "Your progress so far is kept. Leaving is never held against you; it just won't count as finished yet.",
  tsStay: 'Keep going',
  tsLeave: 'Leave',
  tsDebriefLessonEyebrow: 'Lesson finished',
  tsDebriefCheckinEyebrow: 'Check-in finished',
  tsDebriefHeading: "Here's how it went",
  tsDebriefLoading: 'Loading your summary…',
  tsDebriefPartsLabel: 'Parts',
  tsDebriefInfoOnly: 'This is for your information only.',
  tsPracticeDone: 'Practice done',
  tsStartCheckIn: 'Start the check-in',
  tsNextLesson: 'Next lesson',
  tsNextLessonStarting: 'Starting the next lesson…',
  tdAppName: 'Language Tutor',
  tdEyebrowToday: 'Today',
  tdUpNext: 'Up next',
  tdAlsoReady: 'Also ready',
  tdKindLesson: 'Lesson',
  tdKindCheckIn: 'Check-in',
  tdKindReview: 'Review',
  tdStart: 'Start',
  tdMinutes: 'about {n} min',
  tdAllSituations: 'All situations',
  tdBackToToday: '← Today',
  tdFinished:
    "You've finished everything available. Open All situations to redo any lesson or check-in.",
  tdNothingReady: 'Nothing is ready right now. Check back later.',
  tdNoTracks: 'No tracks available. Please check back later.',
  tdSearchLabel: 'Search situations',
  tdSearchPlaceholder: 'Search {n} situations',
  tdFilterLabel: 'Show',
  tdFilterAll: 'All',
  tdFilterOpen: 'Open',
  tdFilterInProgress: 'In progress',
  tdFilterPassed: 'Passed',
  tdNoMatch: 'No situations match “{q}”.',
  tdNoMatchFilter: 'No situations in this view yet.',
  tdThemeOther: 'Other',
  tdThemeCountOne: '1 situation',
  tdThemeCountMany: '{n} situations',
  tdStatePassed: 'Passed',
  tdStatePassedOn: 'Passed {date}',
  tdStateInProgress: 'In progress',
  tdStateLocked: 'Locked',
  tdStateOpen: 'Open',
  tdOpensWhenPass: 'Opens when you pass {names}',
  tdLockedGeneric: 'Not open yet',
  tdMarksLabel: '{done} of {total} lessons done, check-in {check}',
  tdMarksCheckPassed: 'passed',
  tdMarksCheckOpen: 'not passed yet',
  tdSheetClose: 'Close',
  tdLessonN: 'Lesson {n}',
  tdLessonDone: 'Done',
  tdLessonNext: 'Next',
  tdLessonAfter: 'After lesson {n}',
  tdCheckIn: 'Check-in',
  tdCheckInPassed: 'Passed',
  tdCheckInReady: 'Ready',
  tdCheckInSoFar: "Ready for what you've learned so far",
  tdCheckInAfterFirst: 'After lesson 1',
  tdRedo: 'Redo',
  tdReasonCheckIn: "You've done every lesson. This finishes {name}.",
  tdReasonContinue: "You're partway through {name}.",
  tdReasonReviewOne: '1 phrase that was shaky or is due again.',
  tdReasonReview: '{n} phrases that were shaky or are due again.',
  tdReasonReviewLarge:
    '{n} phrases are waiting. A short review keeps them fresh.',
  tdReasonNext: 'A new situation: {blurb}',
  tdTitleLesson: '{name}, lesson {n}',
  tdTitleCheckIn: '{name} check-in',
  tdTitleReviewOne: 'Review 1 phrase',
  tdTitleReview: 'Review {n} phrases',
  tdSignOut: 'Sign out',
  tdSignOutFailed: "Couldn't sign out. Try again.",
  tdLangButton: 'Language: {name}',
  tdLangMenu: 'Languages',
  tdLangPassed: '{n} passed',
  tdLangAdd: 'Add a language',
  tdLangBack: '← Languages',
  tdLangSwitchFailed: "Couldn't switch language. Try again.",
  tdLangPickHeading: 'Pick a language',
  tdLangPickIntro:
    'Choose the language you want to learn. You can add another one later.',
} as const;
